import Naluri from '~/common/api/naluri'
import {
  MODULES_GET_MODULES,
  MODULES_GET_MODULES_ERROR,
} from './constants';

export function getModules(userId) {
  return (dispatch, getState) => {
    Naluri.get(`/api/expert/modules/${userId}`)
      .then(response => {
        dispatch({
          type: MODULES_GET_MODULES,
          data: response
        })
      })
      .catch(err => {
        dispatch({
          type: MODULES_GET_MODULES_ERROR,
          data: { error: err },
        });
      });
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case MODULES_GET_MODULES:
      return {
        ...state,
        modules: action.data.modules,
        categories: action.data.categories
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/modules/redux/getModules.js